import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import Dialog from 'libraries/Dialog';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import TextInput from 'libraries/TextInput';
import clsx from 'clsx';

const styles = {
    progress: {
        color: 'white'
    },
    submitButton: {
        minWidth: 124,
        paddingLeft: 40,
        paddingRight: 40
    },
    cancelButton: {
        fontWeight: 700,
        paddingLeft: 30,
        paddingRight: 30
    },
    input: {
        maxWidth: 500
    }
};

const RejectDialog = observer(({ handleClose, classes, open, updateCredentials, loading, initialValue, otherClasses }) => {
    const [newForm, setNewForm] = useState({});
    const [touched, setTouched] = useState(false);

    useEffect(() => {
        if (open) {
            setTouched(false);
            setNewForm({});
        }
    }, [open]);

    const handleChange = (e) => {
        if (!touched) setTouched(true);
        const { name, value } = e.target;
        setNewForm(prev => ({ ...prev, [name]: value }));
    };

    return (
        <Dialog
            open={open}
            maxWidth="sm"
            onClose={handleClose}
            handleClose={handleClose}
            titleComponent="Update Credentials"
            actionComponent={(
                <>
                    <Button
                        color="primary"
                        className={classes.cancelButton}
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => updateCredentials(newForm)}
                        className={classes.submitButton}
                        disabled={loading || !touched}
                    >
                        {
                            loading ? (
                                <CircularProgress
                                    size={22}
                                    className={classes.progress}
                                />
                            ) : <span>Update</span>
                        }
                    </Button>
                </>
            )}
        >
            <TextInput
                label="Shared Secret key"
                name="secretKey"
                value={newForm.secretKey || initialValue.secretKey}
                onChange={handleChange}
                disabled={loading}
                className={clsx('u-mrg--bx2', classes.input)}
                fullWidth
                variant="outlined"
            />
            <p className={otherClasses.textFieldLabel}>Please paste Shared Secret Key in order to allow the integration.</p>

            <TextInput
                label="Email"
                name="email"
                value={newForm.email || initialValue.email}
                onChange={handleChange}
                disabled={loading}
                className={clsx('u-mrg--bx2', classes.input)}
                fullWidth
                variant="outlined"
            />
            <p className={otherClasses.textFieldLabel}>Please enter the email address of the Breezy user.</p>

            <TextInput
                label="Password"
                name="password"
                type="password"
                value={newForm.password || initialValue.password || ''}
                onChange={handleChange}
                disabled={loading}
                fullWidth
                variant="outlined"
            />
            <p className={otherClasses.textFieldLabel}>Please enter the password of the Breezy user.</p>
        </Dialog>
    );
});

export default withStyles(styles)(RejectDialog);
